import { fakeSample } from 'constants/fakeSample';
import { useEffect, useState } from 'react';
import { PlayerWaveformDataPoints } from '@landr/react-player';
import { Sample } from 'types';
import { log } from 'utils/log';
import { useAxios } from 'hooks';
import { fallbackDatapoints } from '../constants/waveform';
import { EventIds } from '../constants';

const fallbackPlayerWaveformDataPoints = (
    guid: string,
): PlayerWaveformDataPoints => {
    return {
        original: {
            id: guid,
            value: fallbackDatapoints,
        },
        differences: [],
    };
};

type WaveformDataBody = {
    headers: { 'Content-Type': string }; // eslint-disable-line @typescript-eslint/naming-convention
};

type WaveformDataResponse = {
    dataPoints: number[];
};

export const useWaveformData = (
    sample: Sample,
): { dataPoints: PlayerWaveformDataPoints; loading: boolean } => {
    const [loading, setLoading] = useState(true);
    const [dataPoints, setDataPoints] = useState<PlayerWaveformDataPoints>(
        fallbackPlayerWaveformDataPoints(sample.guid),
    );

    const { axiosGet } = useAxios<WaveformDataBody, WaveformDataResponse>();

    useEffect(() => {
        const fetchWaveform = () => {
            sample?.waveformUrl &&
                axiosGet({
                    endpoint: sample.waveformUrl,
                    body: {
                        headers: {
                            'Content-Type': 'application/json', // eslint-disable-line
                        },
                    },
                    thenFn: (res) => {
                        if (res.data.dataPoints) {
                            setDataPoints({
                                original: {
                                    id: sample.guid,
                                    value: res.data.dataPoints || [],
                                },
                                differences: [],
                            });
                        } else {
                            log.error(
                                'Get Waveform Falsy response',
                                EventIds.GetWaveformFailed,
                                new Error('Waveform Falsy Response'),
                                {
                                    guid: sample.guid,
                                    waveformUrl: sample.waveformUrl,
                                },
                            );
                        }
                    },
                    catchFn: (error: unknown) => {
                        log.error(
                            'Get Waveform Failed',
                            EventIds.GetWaveformFailed,
                            error,
                            {
                                guid: sample.guid,
                                waveformUrl: sample.waveformUrl,
                            },
                        );
                    },
                    finallyFn: () => {
                        setLoading(false);
                    },
                });
        };

        const isAValidGuid = sample.guid !== fakeSample.guid;

        isAValidGuid && fetchWaveform();
    }, [sample.guid, sample.waveformUrl, axiosGet]);

    return { dataPoints, loading };
};
